var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              staticStyle: { "text-align": "center", padding: "20px" },
              attrs: { span: 24 },
            },
            [_c("el-image", { attrs: { src: _vm.processPicUrl, alt: "" } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("table-page", {
                ref: "tablePage",
                attrs: {
                  url: _vm.tableUrl,
                  columns: _vm.columns,
                  "page-ing-type": false,
                  "check-box": false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "status",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === "success"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v("通过"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        row.status === "reject"
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("驳回"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }